<div class="content" [ngClass]="userService.isRas ? 'rasContent' : ''">
  <h2 class="title">Tipificación de la alerta</h2>
  <mat-icon class="close-modal" (click)="closeModal()">close</mat-icon>
  <form [formGroup]="form" class="selectRasForms">
    <div class="row">
      <div class="col-12 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Categoría</mat-label>
          <mat-select formControlName="category">
            <mat-option
              *ngFor="let category of categoryExample"
              [value]="category"
              >{{ category }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="type">
            <mat-option *ngFor="let type of typeExample" [value]="type">{{
              type
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Subtipo</mat-label>
          <mat-select formControlName="subType">
            <mat-option
              *ngFor="let subType of subTypeExample"
              [value]="subType"
              >{{ subType }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <!-- <div class="col-12 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Decisión</mat-label>
          <mat-select
            (selectionChange)="changeproceed()"
            formControlName="status"
          >
            <mat-option
              *ngFor="let desition of status"
              [value]="desition.value"
              >{{ desition.status }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div> -->
      <div class="col-12 margTop contentRasSelectorForms">
        <mat-form-field appearance="outline">
          <mat-label>Asignado a</mat-label>
          <mat-select formControlName="assigned">
            <mat-option *ngFor="let user of users" [value]="user._id">
              {{ user.data.nm ? "NM:" + user.data.nm : "" }}
              {{ user.fullname }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div
        *ngIf="form.value.status == 'refused'"
        class="col-12 margTop contentRasSelectorForms"
      >
        <mat-form-field appearance="outline">
          <mat-label>Razón del rechazo</mat-label>
          <textarea matInput formControlName="reason"></textarea>
        </mat-form-field>
      </div> -->
    </div>
  </form>

  <div class="button">
    <button
      mat-raised-button
      class="primary-btn rounded"
      [disabled]="!form.valid || isLoading"
      (click)="save()"
      [ngClass]="userService.isRas ? 'buttonRas' : ''"
    >
      Guardar
    </button>
  </div>
</div>
